module.exports = __webpack_public_path__ + "img/02s.9bb11624.webp";